import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appAlphabetOnly]',
})
export class AlphabetOnlyDirective {
  @Input('appAlphabetSpaceOnly') appAlphabetSpaceOnly: boolean = false;

  constructor(
    public element: ElementRef,
    private control: NgControl
  ) {}

  @HostListener('input', ['$event']) onInput(event: KeyboardEvent) {
    const input = this.element.nativeElement as HTMLInputElement;
    // const regex = /^[a-zA-Z\s]*$/;
    const regex = /^[a-zA-Z][a-zA-Z\s]*$/;
    console.log();

    const value = input.value.trimStart();
    if (!regex.test(value)) {
      const newValue = value.replace(/[^a-zA-Z\s]/g, '');
      this.control.control?.setValue(newValue); //
    }
  }
}
